// UI translations for this locale. Keys must match the es reference bundle —
// enforced by `npm run check:i18n` (scripts/check-i18n-parity.mjs).
export const es = {
  app: { name: 'bitutravel' },
  nav: {
    home: 'Inicio',
    search: 'Buscar',
    login: 'Iniciar sesión',
    register: 'Registrarse',
    dashboard: 'Panel',
    reservas: 'Reservas',
    equipo: 'Equipo',
    logout: 'Cerrar sesión',
    legal: 'Legal',
    legalNotice: 'Aviso legal',
    privacy: 'Política de privacidad',
    cookies: 'Política de cookies',
    terms: 'Términos y condiciones',
    clientes: 'Clientes',
  },
  legal: {
    noticeTitle: 'Aviso legal',
    noticeBody:
      'En cumplimiento de la Ley 34/2002 (LSSI-CE), se informa de que este sitio web es titularidad de bitutravel. Correo de contacto: legal@bitutravel.app. El uso del sitio atribuye la condición de usuario e implica la aceptación de las presentes condiciones.',
    privacyTitle: 'Política de privacidad',
    privacyBody:
      'Tratamos sus datos únicamente para gestionar su cuenta, sus reservas y la facturación exigida por la normativa española (RGPD y LOPDGDD). Nunca cedemos sus datos a terceros con fines comerciales. Puede ejercer sus derechos de acceso, rectificación, supresión y portabilidad escribiendo a privacy@bitutravel.app.',
    cookiesTitle: 'Política de cookies',
    cookiesBody:
      'bitutravel solo utiliza cookies técnicas imprescindibles: sesión de autenticación y preferencia de idioma. No usamos cookies publicitarias ni de seguimiento de terceros.',
    termsTitle: 'Términos y condiciones',
    termsBody:
      'Las reservas se solicitan a través de la plataforma y quedan sujetas a la aprobación del propietario y a la política de cancelación elegida. La facturación corporativa se emite conforme a la normativa española (IVA e IRPF aplicables). bitutravel actúa como intermediario entre la empresa solicitante y el propietario del alojamiento. Los precios mostrados no incluyen IVA (21%), que se añade al total de la reserva.',
  },
  landing: {
    heroTitle: 'Alojamiento corporativo sin complicaciones',
    heroSubtitle:
      'Encuentre alojamiento de calidad a medio plazo para sus equipos en toda España. Con la confianza de empresas líderes.',
    checkIn: 'Entrada',
    checkOut: 'Salida',
    guests: 'Huéspedes',
    search: 'Buscar',
    featured: 'Estancias destacadas',
    featuredIn: 'Destacados en {{city}}',
    guestsValue: '{{count}} huéspedes',
    where: 'Dónde',
    when: 'Cuándo',
    who: 'Quién',
    searchDestinations: 'Buscar destinos',
    addDates: 'Añadir fechas',
    addGuests: 'Añadir huéspedes',
    howItWorks: 'Cómo funciona',
    step1Title: 'Busca',
    step1Desc: 'Explora alojamientos verificados en las principales ciudades de España.',
    step2Title: 'Reserva',
    step2Desc: 'Reserva estancias de media duración para sus equipos con condiciones corporativas.',
    step3Title: 'Múdate',
    step3Desc: 'Su equipo se aloja. Nosotros gestionamos la factura y el parte de viajero.',
    perNight: '/ noche',
    perNightPlusIva: '/ noche + IVA',
    comingSoon: 'Próximamente',
    trustedBy: 'Ya confían en nosotros',
    testimonialsTitle: 'Lo que dicen nuestros clientes',
    review1Text: 'Desde que uso bitutravel nos llegan las facturas y simplifica todo el proceso.',
    review1Author: 'María López',
    review1Role: 'Responsable de movilidad, consultora tecnológica',
    review2Text: 'Gestionamos el alojamiento de todo el equipo en una sola plataforma. El ahorro en tiempo y costes es evidente.',
    review2Author: 'Javier Ruiz',
    review2Role: 'Director de operaciones, empresa de ingeniería',
    review3Text: 'La facturación corporativa y el parte de viajero vienen listos para auditar. Cero trabajo administrativo.',
    review3Author: 'Elena García',
    review3Role: 'Responsable financiero, multinacional',
    illustrativeImage: 'imagen ilustrativa',
  },
  search: {
    allSpain: 'Toda España',
    allDistricts: 'Todos los distritos',
    viewAllResults: 'Ver todos los resultados',
    results: 'resultados',
    sort: 'Ordenar',
    sortPriceAsc: 'Precio: menor a mayor',
    sortPriceDesc: 'Precio: mayor a menor',
    noResults: 'No hay alojamientos en esta zona.',
    noResultsForFilters: 'No hay alojamientos para estos filtros. Prueba a quitar fechas o cambiar los filtros.',
    clearFilters: 'Quitar filtros',
    areaPlaceholder: 'Barrio, zona o código postal',
    showMap: 'Mapa',
    showMore: 'Ver más',
    backToTop: 'Volver arriba',
    typeAll: 'Todo',
    placeEntire: 'Apartamento entero',
    placeRoom: 'Habitación',
    placeHotel: 'Hotel',
    dates: 'Fechas',
    sortRecommended: 'Recomendado',
    size: 'Dormitorios',
    sizeAny: 'Cualquiera',
    sizeSingle: '1 dormitorio',
    sizeDouble: '2 dormitorios',
    size3plus: '3+ dormitorios',
    rooms: 'Habitaciones',
    units: 'Unidades',
    grouping: 'Agrupar',
    groupAny: 'Cualquiera',
    typeInCity: '{{type}} en {{city}}',
    forNights: 'por {{count}} noches',
    filters: 'Filtros',
    groupSameBuilding: 'Mismo edificio',
    groupSameArea: 'Zona cercana',
    groupSameCategory: 'Misma categoría',
    roomsValue: '{{count}} hab.',
    unitsValue: '{{count}} uds.',
    groupResults: 'grupos',
    fromPrice: 'desde {{price}}',
    unitsInBuilding: '{{count}} unidades en este edificio',
    groupUnits: 'unidades',
    sameBuilding: 'Mismo edificio',
    sameArea: 'Zona cercana',
    sameCategory: 'Misma categoría',
    anyGroup: 'Unidades',
    priceFrom: 'desde',
    bookAll: 'Reservar las {{count}}',
    playTour: 'Reproducir recorrido',
    approxMapNote: 'Las ubicaciones son aproximadas. Regístrate para ver la ubicación exacta.',
    pauseTour: 'Pausar recorrido',
    bookAllTitle: 'Reservar el grupo',
    bookAllDesc: 'Reserva las {{count}} unidades como un mismo conjunto.',
    bookAllSummary: '{{count}} unidades · {{nights}} noches',
    bookAllSomeFailed: 'Algunas unidades no se pudieron reservar.',
    bookAllDone: 'Conjunto reservado ({{ok}}/{{count}}).',
    structRoomIn: 'Habitación en {{building}}',
    structRoomsSameApartment: '{{count}} habitaciones en el mismo apartamento',
    structRoomsSameBuilding: '{{count}} habitaciones en el mismo edificio',
    structApartmentsSameBuilding: '{{count}} apartamentos en el mismo edificio',
    structStaysSameArea: '{{count}} alojamientos en la misma zona',
    structStaysSameCategory: '{{count}} alojamientos · {{category}}',
    structUnits: '{{count}} unidades',
    specFull: '{{guests}} huéspedes · {{bedrooms}} dormitorios · {{baths}} baños',
    specShort: '{{bedrooms}} dorm. · {{baths}} baño',
  },
  detail: {
    guests: 'huéspedes',
    bedrooms: 'dormitorios',
    bathrooms: 'baños',
    amenities: 'Servicios',
    location: 'Ubicación',
    nights: 'noches',
    cleaningFee: 'Limpieza',
    total: 'Total',
    iva: 'IVA ({{pct}}%)',
    ivaNote: 'Precios sin IVA: se añade el 21% de IVA al total de la reserva. Factura corporativa conforme.',
    bookNow: 'Reservar ahora',
    loginToBook: 'Inicia sesión para reservar',
    signInForDetails: 'Inicia sesión para ver los detalles completos.',
    approxLocation: 'Ubicación aproximada (radio de ~700 m)',
    checkin: 'Entrada',
    checkout: 'Salida',
    tooManyGuests: 'Esta propiedad admite hasta {{capacity}} huéspedes.',
    minStayWarning: 'Estancia mínima: {{count}} noche | Estancia mínima: {{count}} noches',
    nightsWithCount: '{{count}} noche | {{count}} noches',
  },
  booking: {
    title: 'Reservar ahora',
    subtitle: 'Verifica los datos del viajero. El importe se recalcula en el servidor.',
    confirm: 'Confirmar reserva',
    guestName: 'Nombre del viajero',
    guestNamePlaceholder: 'Nombre y apellidos',
    guestNif: 'NIF del viajero',
    datesRequired: 'Selecciona fechas válidas',
    nameRequired: 'Introduce el nombre del viajero',
    nifInvalid: 'NIF no válido',
    requestCreated: 'Reserva creada. Pendiente de pago.',
    notAvailable: 'Esas fechas ya no están disponibles.',
    notApproved: 'Tu cuenta no está aprobada para reservar.',
    createError: 'No se pudo crear la reserva. Inténtalo de nuevo.',
    awaitingDesc: 'Reserva creada. Realiza el pago para confirmarla.',
    totalWithIva: 'Total (IVA incluido)',
    priceEstimateNote: 'Precio estimado: el importe final lo calcula bitutravel al reservar.',
    total: 'Total',
    reference: 'Referencia',
    openPaymentLink: 'Abrir enlace de pago',
    mockDevNote:
      'Modo desarrollo: el pago es simulado. Pulsa para marcar como pagado y simular el webhook de Revolut.',
    markPaidDev: 'Marcar como pagado (dev)',
    markPaidError: 'No se pudo simular el pago.',
    paid: 'Pago confirmado',
    paidDesc: 'Tu reserva está confirmada. Recibirás la factura por correo.',
    viewBookings: 'Ver mis reservas',
    paymentStatus: 'Pago',
    bookingsTitle: 'Mis reservas',
    browseStays: 'Buscar alojamiento',
    summaryTotal: 'Reservas',
    summaryUpcoming: 'Próximas',
    summaryInstay: 'En estancia',
    summarySpend: 'Gasto total',
    summaryPendingNote: 'Tienes {{count}} reservas pendientes de pago.',
    payStatusPaid: 'Pagado',
    payStatusPending: 'Pendiente',
    payStatusAwaiting: 'Pendiente de pago',
    payStatusRefunded: 'Reembolsado',
    payStatusFailed: 'Fallido',
    payStatusScheduled: 'Programado',
    empty: 'Todavía no tienes reservas.',
    statusAwaitingPayment: 'Pendiente de pago',
    statusConfirmed: 'Confirmada',
    statusActive: 'En curso',
    statusCompleted: 'Completada',
    statusCancelled: 'Cancelada',
    statusDisputed: 'En disputa',
    notFound: 'Reserva no encontrada.',
    viewProperty: 'Ver propiedad',
    cleaningFee: 'Limpieza',
    platformFee: 'Comisión bitutravel',
    cancelBooking: 'Cancelar reserva',
    cancelConfirm: '¿Seguro que quieres cancelar esta reserva? Esta acción no se puede deshacer.',
    cancelConfirmYes: 'Sí, cancelar',
    cancelledToast: 'Reserva cancelada.',
    cancelError: 'No se pudo cancelar la reserva.',
    cancelReason: 'Motivo de cancelación',
    copyLink: 'Copiar enlace',
    tabFuture: 'Próximas',
    tabPresent: 'En curso',
    tabPast: 'Pasadas',
    emptyTab: 'No hay reservas en esta sección.',
    purpose: 'Motivo del viaje',
    purposeLeisure: 'Personal',
    purposeConference: 'Congreso / evento',
    purposeProject: 'Proyecto',
    purposeRelocation: 'Reubicación',
    purposeOther: 'Otro',
    eventName: 'Nombre del evento',
    eventNamePlaceholder: 'Ej. Mobile World Congress 2026',
    teamSize: 'Personas',
    teamNotes: 'Detalles del equipo',
    teamNotesPlaceholder: 'Nombres de los viajeros, habitación, notas…',
    teamDetails: 'Detalle del viaje / equipo',
    employee: 'Empleado',
    employeePlaceholder: 'Sin asignar',
    employeeNone: 'Sin empleado',
    employeeFilterAll: 'Todos los empleados',
    employeeCardTitle: 'Empleado asignado',
  },
  team: {
    title: 'Equipo',
    addEmployee: 'Añadir empleado',
    intro: 'Gestiona los empleados de tu empresa. Asígnales reservas para que reciban los detalles por email, o actívalos para que puedan hacer sus propias reservas a cargo de la empresa.',
    featureRosterTitle: 'Ficha de empleados',
    featureRosterDesc: 'Nombre, email, teléfono y NIF de cada empleado. La mayoría son recurrentes: los reutilizas en cada reserva.',
    featureEmailTitle: 'Detalles por email',
    featureEmailDesc: 'Al hacer una reserva, asigna el empleado y recibe los datos del alojamiento por correo.',
    featureActivateTitle: 'Activar para reservar',
    featureActivateDesc: 'Activa un empleado para que entre con su propio email y haga reservas a cargo de la empresa.',
    empty: 'Aún no hay empleados. Pronto podrás añadirlos y asignarlos a tus reservas.',
    editEmployee: 'Editar empleado',
    editDesc: 'Modifica los datos de contacto del empleado.',
    addDesc: 'Añade un empleado y actívalo para que entre con su propio email.',
    addNote: 'Se añadirá a la ficha de empleados. Para que entre con su propio email, activa su acceso después.',
    activateLogin: 'Activar acceso',
    alreadyActivated: 'Este empleado ya tiene acceso activado.',
    platformUnavailable: 'El servicio no está disponible ahora. Inténtalo más tarde.',
    phone: 'Teléfono',
    updated: 'Empleado actualizado.',
    added: 'Empleado añadido.',
    emailExists: 'Ya existe un empleado con ese email.',
    activated: 'Empleado activado.',
    deactivated: 'Empleado desactivado.',
    deleted: 'Empleado eliminado.',
    activate: 'Activar',
    deactivate: 'Desactivar',
    delete: 'Eliminar',
    deleteTitle: 'Eliminar empleado',
    deleteConfirm: '¿Seguro que quieres eliminar a {{name}}? Se borrará su cuenta y no se podrá deshacer.',
    statusActive: 'Activo',
    statusInactive: 'Inactivo',
    statusRoster: 'Solo ficha',
    tempPwTitle: 'Contraseña temporal',
    tempPwDesc: 'Esta es la contraseña temporal de {{name}}. Compártela con la persona de forma segura.',
    tempPwWarn: 'No se volverá a mostrar. Cópiala ahora.',
    copy: 'Copiar',
    copied: 'Copiado',
  },
  agency: {
    title: 'Clientes',
    intro: 'Gestiona las empresas cliente de tu agencia. Añádelas con su email de facturación y reserva viajes a su nombre: la factura va a la empresa cliente.',
    addClient: 'Añadir empresa cliente',
    clientEmail: 'Email de facturación de la empresa',
    clientEmailPlaceholder: 'facturas@empresa.es',
    addNote: 'La empresa debe tener cuenta en bitutravel y estar aprobada. Se validará al enlazarla.',
    empty: 'Aún no tienes empresas cliente. Añádelas para empezar a reservar a su nombre.',
    client: 'Cliente',
    unknownClient: 'Empresa cliente',
    unlinkConfirm: '¿Seguro que quieres desvincular a {{name}}? Ya no podrás reservar a su nombre.',
    unlinkedBtn: 'Desvincular',
    unlinked: 'Empresa cliente desvinculada.',
    linked: 'Empresa cliente vinculada: {{name}}.',
    notFound: 'No se encontró ninguna empresa aprobada con ese email.',
    billTo: 'Reservar para',
    selectClient: 'Selecciona una empresa cliente',
    noClientsWarn: 'Añade primero una empresa cliente en Clientes para poder reservar.',
  },

  invoices: {
    title: 'Facturas y partes',
    backToBookings: '← Mis reservas',
    count: 'Facturas',
    baseTotal: 'Base imponible',
    ivaTotal: 'IVA',
    irpfTotal: 'IRPF retenido',
    total: 'Total facturado',
    invoicesTitle: 'Facturas',
    ref: 'Reserva',
    parteTitle: 'Partes de viajero',
    parteEmpty: 'Aún no hay partes de viajero.',
    empty: 'Aún no tienes facturas. Se generan automáticamente al confirmar una reserva.',
    regenTitle: 'Reemitir documentos',
    regenDesc: 'Regenera la factura y el parte de viajero de una reserva (útil para contabilidad).',
    regenDone: 'Documentos regenerados.',
    regenError: 'No se pudieron regenerar los documentos.',
    downloadError: 'No se pudo descargar el documento.',
    navInvoices: 'Facturas',
    period30: 'Últimos 30 días',
    period90: 'Últimos 90 días',
    period365: 'Últimos 12 meses',
    periodAll: 'Todo el histórico',
    periodEmpty: 'No hay facturas en este periodo.',
    exportCsv: 'Exportar CSV',
    exportZip: 'Descargar PDF (ZIP)',
    statusIssued: 'Emitida',
    statusPaid: 'Pagada',
    statusVoid: 'Anulada',
  },
  owner: {
    revenueTitle: 'Ingresos',
    invoicesTitle: 'Facturas y cobros',
    invoicesNote: 'Las facturas se generan automáticamente al confirmar una reserva; los pagos se liquidan según el calendario de bitutravel.',
    gross: 'Base (sin IVA)',
    fee: 'Comisión bitutravel',
    iva: 'IVA',
    net: 'Ingreso neto',
    paidOut: 'Pagado',
    pending: 'Pendiente de pago',
    monthlyTitle: 'Ingresos por mes',
    perPropertyTitle: 'Por propiedad',
    property: 'Propiedad',
    bookings: 'Reservas',
    nights: 'Noches',
    payoutsTitle: 'Pagos a propietario',
    eligibleDesc: 'Reservas confirmadas listas para pagar:',
    payNow: 'Pagar',
    scheduled: 'Programado',
    noPayouts: 'Aún no hay pagos.',
    noData: 'Sin datos todavía.',
    payoutDone: 'Pago emitido.',
    payoutError: 'No se pudo emitir el pago.',
    range7: '7 d',
    range15: '15 d',
    range30: '30 d',
    range90: '90 d',
    range12m: '12 m',
    rangeAll: 'Todo',
    payoutConfirmTitle: 'Confirmar pago',
    payoutConfirmDesc: '¿Emitir el pago de la reserva #{{id}} por {{amount}}?',
    confirm: 'Confirmar',
    propertiesNav: 'Calendario',
    propertiesTitle: 'Calendario',
    newProperty: 'Añadir propiedad',
    editProperty: 'Editar',
    propertyUntitled: 'Propiedad sin título',
    propertiesEmpty: 'Todavía no has publicado ninguna propiedad.',
    pendingReviewNote: 'Las propiedades nuevas quedan en revisión hasta que el equipo de bitutravel las apruebe. Te avisaremos por correo.',
    pendingEditorNote: 'Esta propiedad está en revisión. Podrás editarla; aparecerá en la búsqueda cuando sea aprobada.',
    unpublished: 'No publicada',
    photoCount: '{{count}} fotos',
    noPhotos: 'Sin fotos',
    unitCount: '{{count}} unidades',
    viewCalendar: 'Calendario',
    viewList: 'Lista',
    searchUnits: 'Buscar unidades…',
    sortName: 'Nombre',
    sortRecent: 'Recientes',
    chipNeedsPhotos: 'Sin fotos',
    stripNoBookings: 'Sin reservas en los próximos 30 días',
    pms: {
      title: 'Gestor de reservas',
      subtitle: 'Reservas por unidad — arrastra para mover',
      prev: 'Anterior',
      next: 'Siguiente',
      today: 'Hoy',
      view_month: 'Mes',
      view_week: 'Semana',
      dragHint: 'Arrastra una reserva a otra unidad o fecha para moverla.',
      moved: 'Reserva movida',
      moveError: 'No se pudo mover la reserva',
      noCity: 'Sin ciudad',
      cities: 'Ciudades',
      properties: 'Propiedades',
      unit: 'Unidad',
      overall: 'Visión global',
      allProperties: 'Todas las propiedades',
      noUnits: 'Aún no tienes unidades. Añade una propiedad para empezar.',
      guest: 'Huésped',
      dragHintBlocked: 'Haz clic en un día vacío para bloquearlo / abrirlo. Arrastra una reserva para moverla; arrastra su borde derecho para ampliar o acortar.',
      addBooking: 'Añadir reserva',
      dates: 'Fechas',
      autoRate: 'Tarifa automática',
      applyCustomPrice: 'Aplicar precio personalizado (descuento)',
      customPriceHint: 'Edita el total para aplicar un descuento. Se reparte entre las noches.',
      manualBooking: 'Reserva manual',
      manualBadge: 'Manual',
      guestName: 'Nombre del huésped',
      guestNif: 'NIF del huésped',
      guests: 'Huéspedes',
      pricePerNight: 'Precio por noche',
      checkin: 'Entrada',
      checkout: 'Salida',
      block: 'Bloquear',
      unblock: 'Abrir',
      blocked: 'Bloqueado',
      blockTitle: 'Bloquear noche',
      blockNameLabel: 'Nombre (opcional)',
      blockNamePlaceholder: 'p. ej. Mantenimiento',
      blockNameHint: 'Se mostrará en el día bloqueado.',
      blockConfirm: 'Bloquear',
      manualCreated: 'Reserva manual creada',
      manualError: 'No se pudo crear la reserva manual',
      notAvailable: 'No disponible para esas fechas',
      belowMinStay: 'Por debajo de la estancia mínima de esta unidad',
      detail: 'Detalle de la reserva',
      property: 'Propiedad',
      nights: 'Noches',
      total: 'Total',
      iva: 'IVA',
      fee: 'Comisión de la plataforma',
      payout: 'Pago',
      channel: 'Canal',
      status: 'Estado',
      statusConfirmed: 'Confirmada',
      statusActive: 'En estancia',
      statusPending: 'Pendiente',
      statusAwaiting: 'Pendiente de pago',
      statusCancelled: 'Cancelada',
      channelManual: 'Manual',
      channelDirect: 'Directo',
      channelIcal: 'iCal (importado)',
      icalNoPayout: 'Bloqueo externo — sin pago',
      confirmMove: 'Confirmar movimiento',
      moveFrom: 'Desde',
      moveTo: 'Hasta',
      moveNote: 'La disponibilidad y el precio se revalidan al confirmar.',
      confirm: 'Confirmar',
      extendTitle: 'Ampliar estancia',
      shortenTitle: 'Acortar estancia',
      newCheckout: 'Nueva salida',
      extended: 'Estancia actualizada',
      extendError: 'No se pudo actualizar la estancia',
    },
    status: {
      pending: 'En revisión',
      approved: 'Publicado',
      rejected: 'Rechazada',
    },
    products: {
      nav: 'Propiedades',
      title: 'Propiedades',
      subtitle: 'Tarifas y canales por unidad. La tarifa por defecto se sincroniza con el precio de la propiedad.',
      empty: 'Todavía no tienes propiedades.',
      ratePlans: 'Tarifas',
      addRatePlan: 'Añadir tarifa',
      editRatePlan: 'Editar tarifa',
      ratePlanDesc: 'Una tarifa es una oferta vendible de esta unidad (precio, limpieza, estancia mínima).',
      noPlans: 'Sin tarifas todavía.',
      planCount: '{{count}} tarifas',
      icalCount: '{{count}} iCal',
      default: 'Por defecto',
      inactive: 'Inactiva',
      minNights: 'mín. {{count}} noches',
      minNightsLabel: 'Noches mínimas',
      feePct: 'comisión {{pct}}%',
      feePctLabel: 'Comisión bitutravel (%)',
      feePctPlaceholder: 'predeterminada',
      feePctHint: 'Vacío = comisión global. 0 = cliente propio (sin comisión).',
      makeDefault: 'Tarifa por defecto',
      name: 'Nombre',
      basePrice: 'Precio base (NET)',
      cleaningFee: 'Limpieza',
      cancellation: 'Cancelación',
      policy: {
        flexible: 'Flexible',
        moderate: 'Moderada',
        strict: 'Estricta',
      },
      save: 'Guardar',
      cancel: 'Cancelar',
      edit: 'Editar',
      delete: 'Eliminar',
      confirmDelete: '¿Eliminar?',
      defaultNoDelete: 'No se puede eliminar la tarifa por defecto.',
      created: 'Tarifa creada.',
      updated: 'Tarifa actualizada.',
      deleted: 'Tarifa eliminada.',
      channels: 'Canales',
      addChannel: 'Añadir canal',
      direct: 'Directo',
      noConnections: 'Sin conexiones. Añade un canal iCal para importar un calendario externo.',
      icalChannel: 'iCal',
      addIcal: 'Añadir conexión iCal',
      icalDesc: 'Pega la URL iCal de un calendario externo (Airbnb, Booking, Google…). Las fechas reservadas bloquearán esta unidad.',
      icalUrl: 'URL del calendario iCal',
      addAndSync: 'Añadir y sincronizar',
      syncNow: 'Sincronizar',
      syncAll: 'Sincronizar todo',
      syncDone: '{{upserted}} importadas, {{cancelled}} canceladas, {{conflicts}} conflictos',
      syncAllDone: 'Sincronización completa: {{upserted}} importadas, {{cancelled}} canceladas, {{conflicts}} conflictos',
      syncError: 'Error de sincronización',
      lastSync: 'Última sincronización',
      neverSynced: 'Sin sincronizar todavía',
      connectionDeleted: 'Conexión eliminada.',
      connStatus: {
        pending: 'Pendiente',
        active: 'Activa',
        paused: 'Pausada',
        error: 'Error',
      },
      rangeActionTitle: 'Rango seleccionado',
      rangeActionHint: '¿Qué quieres hacer con estas noches?',
      selectHint: 'Haz clic en una noche y luego en otra (o dos veces en la misma) para elegir un rango.',
    },
    calendar: {
      title: 'Calendario de tarifas',
      subtitle: 'Precio, estancia mínima y disponibilidad noche a noche',
      navButton: 'Tarifas',
      backendRequired: 'Configura el backend de Supabase para usar el calendario de tarifas.',
      basePrice: 'Tarifa base',
      cleaningFee: 'Limpieza',
      applyTitle: 'Aplicar a la selección',
      clearSelection: 'Quitar selección',
      selectHint: 'Haz clic en una noche y luego en otra para elegir un rango. Cada casilla es una noche: la última marcada es la noche previa a la salida.',
      selectedNights: '{{count}} noche seleccionada | {{count}} noches seleccionadas',
      skipped: '{{count}} noche omitida (reservada o pasada) | {{count}} noches omitidas (reservadas o pasadas)',
      noneEditable: 'Todas las noches seleccionadas están reservadas o ya han pasado.',
      priceLabel: 'Nuevo precio (€)',
      pricePlaceholder: '€ / noche',
      minNightsLabel: 'Estancia mínima (noches)',
      minNightsPlaceholder: 'p. ej. 5',
      applyPrice: 'Fijar precio',
      applyMinNights: 'Fijar mínima',
      block: 'Bloquear',
      unblock: 'Abrir',
      removeOverride: 'Quitar personalización',
      blockNameLabel: 'Nombre del bloque',
      blockNamePlaceholder: 'p. ej. Mantenimiento, Obra…',
      saved: 'Calendario actualizado',
      saveError: 'No se pudo guardar el calendario.',
      legend: {
        available: 'Disponible',
        priced: 'Precio personalizado',
        blocked: 'Bloqueada',
        booked: 'Reservada',
        past: 'Pasada',
        sunday: 'Domingo',
      },
      ical: {
        title: 'Exportar calendario (iCal)',
        desc: 'Enlaza este feed con Airbnb, Booking.com o tu channel manager para sincronizar las reservas.',
        copy: 'Copiar',
        copied: 'Enlace copiado',
        unavailable: 'Feed no disponible para esta propiedad.',
      },
      bulk: {
        from: 'Desde',
        to: 'Hasta',
        allDays: 'Todos los días',
        weekdays: 'Entre semana',
        weekends: 'Fines de semana',
        allYear: 'Todo el año',
        pickDay: 'Selecciona al menos un día de la semana',
      },
    },
    step1: 'Datos',
    step2: 'Descripción',
    step3: 'Ubicación y fotos',
    backStep: 'Atrás',
    nextStep: 'Siguiente',
    saveProperty: 'Guardar propiedad',
    fieldType: 'Tipo de alojamiento',
    type: {
      apartment: 'Apartamento',
      studio: 'Estudio',
      house: 'Casa',
      room: 'Habitación',
      loft: 'Loft',
      duplex: 'Dúplex',
      cabin: 'Cabaña',
      guesthouse: 'Casa de huéspedes',
      hotel: 'Hotel',
      bed_breakfast: 'Casa rural',
    },
    fieldCapacity: 'Capacidad (huéspedes)',
    fieldBeds: 'Camas',
    fieldPrice: 'Precio por noche (€)',
    fieldCleaning: 'Tarifa de limpieza (€)',
    fieldCheckinTime: 'Hora de entrada',
    fieldCheckoutTime: 'Hora de salida',
    fieldTitleEs: 'Título (español)',
    fieldTitleEn: 'Título (inglés)',
    fieldDescEs: 'Descripción (español)',
    fieldDescEn: 'Descripción (inglés)',
    fieldCity: 'Ciudad',
    fieldCategory: 'Categoría',
    fieldCategoryHint: 'ejecutiva, estándar, suite…',
    fieldBuilding: 'Edificio / dirección',
    fieldUnitLabel: 'Etiqueta de la unidad',
    fieldNeighborhood: 'Barrio / Distrito',
    fieldNeighborhoodHint: 'Ej. Chamberí',
    fieldPostalCode: 'Código postal',
    cityPrefillNote: 'Al elegir ciudad rellenamos las coordenadas con el centro; ajústalas si conoces la ubicación exacta.',
    photosAfterCreate: 'Guarda la propiedad para poder añadir fotos.',
    addPhotos: 'Añadir fotos',
    deletePhoto: 'Eliminar foto',
    photoUploadError: 'No se pudo subir la foto.',
    photoDeleteError: 'No se pudo eliminar la foto.',
    createdToast: 'Propiedad creada. Está en revisión.',
    savedToast: 'Propiedad guardada.',
    saveError: 'No se pudo guardar la propiedad.',
    fiscal: {
      title: 'Datos fiscales y VeriFactu',
      subtitle: 'Información del emisor y autorización para que bitutravel remita tus facturas a la AEAT.',
      statusActive: 'VeriFactu activo. Tus facturas de alojamiento se remiten a la AEAT.',
      statusPending: 'VeriFactu pendiente. Tus facturas se emiten pero no se remiten a la AEAT.',
      statusRevoked: 'Tu autorización ha sido revocada. La remisión a la AEAT está pausada.',
      active: 'Activo',
      pending: 'Pendiente',
      revoked: 'Revocado',
      issuerTitle: 'Datos del emisor',
      personaType: 'Tipo de persona',
      personaF: 'Física',
      personaJ: 'Jurídica',
      seriesLodging: 'Serie de facturas',
      seriesHint: 'Serie AEAT para tus facturas de alojamiento (por defecto O). No la cambies sin causa.',
      legalName: 'Razón social / Nombre',
      nif: 'NIF',
      country: 'País',
      street: 'Dirección',
      postalCode: 'Código postal',
      city: 'Población',
      save: 'Guardar datos fiscales',
      saved: 'Datos fiscales guardados.',
      saveError: 'No se pudieron guardar los datos fiscales.',
      errFields: 'Razón social y NIF son obligatorios.',
      apoderamientoTitle: 'Apoderamiento',
      apoderamientoDesc: 'Para remitir facturas a la AEAT en tu nombre, bitutravel necesita un poder de representación firmado. Sube el poder firmado para activar la remisión.',
      poderOnFile: 'Poder registrado:',
      uploadPoder: 'Subir poder firmado (PDF)',
      poderHint: 'PDF, máx. 10 MB.',
      granted: 'Apoderamiento activado. VeriFactu remitirá tus próximas facturas.',
      grantError: 'No se pudo registrar el poder.',
      errPoderSize: 'El archivo supera los 10 MB.',
      legalNote: 'Al subir el poder confirmas que has firmado la autorización de representación para que bitutravel remita facturas a la AEAT (RD 1007/2023).',
      bannerPending: 'Activa VeriFactu para remitir tus facturas a la AEAT.',
      bannerRevoked: 'Tu autorización VeriFactu está revocada.',
      bannerCta: 'Configurar',
    },

  },
  profile: {
    title: 'Perfil y ajustes',
    navProfile: 'Perfil',
    accountSection: 'Cuenta',
    statusLabel: 'Estado de la cuenta',
    rejectionReason: 'Motivo del rechazo',
    detailsSection: 'Datos fiscales',
    languageSection: 'Idioma',
    localeLabel: 'Idioma preferido',
    localeHint: 'Se guarda en tu cuenta y se aplica en todos tus dispositivos.',
    localeSaved: 'Idioma actualizado.',
    billingSection: 'Facturación y pago',
    invoiceEmail: 'Email de facturación',
    invoiceEmailPlaceholder: 'facturas@tuempresa.es',
    ibanTransfer: 'IBAN (pago por transferencia)',
    ibanHint: 'Si prefieres pagar por transferencia bancaria.',
    preferredMethod: 'Método de pago preferido',
    methodCard: 'Tarjeta',
    methodTransfer: 'Transferencia',
    savedCards: 'Tarjetas guardadas',
    defaultCard: 'Predeterminada',
    billingProcessorNote: 'Los datos de tarjeta se tokenizan con Revolut; nunca almacenamos el número completo.',
    billingSaved: 'Facturación actualizada.',
  },
  auth: {
    registerTitle: 'Crear cuenta',
    loginTitle: 'Iniciar sesión',
    rolePrompt: '¿Cómo vas a usar bitutravel?',
    roleBookerPrompt: '¿Quién reserva?',
    roleBook: 'Reservo estancias',
    roleList: 'Publico propiedades',
    pathManager: 'Gestiono propiedades',
    pathManagerDesc: 'Publica tu inventario y gestiona tarifas y disponibilidad',
    pathBook: 'Reservo estancias',
    pathBookDesc: 'Para empresas, empleados y autónomos que se alojan',
    roleCompany: 'Empresa',
    roleAutonomo: 'Autónomo',
    roleEmployee: 'Trabajo en una empresa',
    roleEmployeeDesc: 'Reservo con la tarjeta de mi empresa; la factura va a ella',
    roleOwner: 'Propietario',
    roleEmployeeLabel: 'Empleado',
    roleAgencyLabel: 'Agencia',
    roleCompanyDesc: 'Reservas centralizadas para su empresa',
    roleAutonomoDesc: 'Para profesionales autónomos',
    roleOwnerDesc: 'Para publicar y monetizar tus propiedades',
    contactName: 'Persona de contacto',
    email: 'Correo electrónico',
    fullName: 'Nombre completo',
    legalName: 'Razón social',
    cif: 'CIF',
    nif: 'NIF / DNI',
    address: 'Dirección',
    iban: 'IBAN para cobros',
    irpf: 'Retención IRPF (%)',
    submit: 'Enviar solicitud',
    pendingTitle: 'Solicitud en revisión',
    pendingDesc: 'Nuestro equipo está verificando tu cuenta. Te avisaremos por correo cuando sea aprobada.',
    pendingApproved: '¡Tu cuenta ha sido aprobada!',
    checkStatus: 'Comprobar de nuevo',
    profileErrorTitle: 'No pudimos cargar tu perfil',
    profileErrorDesc:
      'Tu sesión es válida pero no encontramos los datos de tu cuenta. Vuelve a intentarlo o cierra sesión.',
    rejectedTitle: 'Solicitud rechazada',
    rejectedDesc: 'Tu solicitud no ha sido aprobada. Motivo: {{reason}}',
    loginPrompt: '¿Ya tienes cuenta? Inicia sesión',
    registerPrompt: '¿No tienes cuenta? Regístrate',
    login: 'Iniciar sesión',
    magicLink: 'Enviar enlace mágico',
    magicLinkSent:
      'Te hemos enviado un enlace mágico a tu correo. Ábrelo para iniciar sesión.',
    cifInvalid: 'CIF no válido',
    cifInRegistry: 'Encontrada en el directorio',
    nifOrCifInvalid: 'NIF/CIF no válido',
    ibanInvalid: 'IBAN no válido',
    irpfRange: 'Debe estar entre 7 y 45 %',
    loginErrorGeneric: 'No se pudo iniciar sesión. Revisa el correo.',
    loginRateLimited: 'Demasiados intentos. Espera un minuto.',
    loginEmailNotConfirmed: 'Confirma tu correo antes de iniciar sesión.',
  },
  admin: {
    approvalsTitle: 'Cola de aprobaciones',
    approve: 'Aprobar',
    reject: 'Rechazar',
    reason: 'Motivo',
    empty: 'No hay solicitudes pendientes',
    typeCompany: 'Empresa',
    typeAutonomo: 'Autónomo',
    typeOwner: 'Propietario',
    approvedToast: 'Solicitud aprobada',
    rejectedToast: 'Solicitud rechazada',
    decisionFailed: 'No se pudo guardar la decisión',
    searchPlaceholder: 'Buscar por nombre, email o NIF/CIF',
    tabAll: 'Todas',
    tabCompany: 'Empresas',
    tabAutonomo: 'Autónomos',
    tabOwner: 'Propietarios',
    confirmApprove: '¿Aprobar a {{name}}?',
    confirmReject: 'Rechazar a {{name}}?',
    confirm: 'Confirmar',
    reasonRequired: 'Indica el motivo del rechazo',
    noMatches: 'Sin resultados',
    roleAdmin: 'Administración',
    consoleTitle: 'Consola de administración',
    navApprovals: 'Aprobaciones',
    navAccounts: 'Cuentas',
    navBookings: 'Reservas',
    navInvoices: 'Facturas',
    tabAgency: 'Agencias',
    tabEmployee: 'Empleados',
    tabBlocked: 'Bloqueados',
    typeAgency: 'Agencia',
    typeEmployee: 'Empleado',
    typeAdmin: 'Administrador',
    typeSuperadmin: 'Superadmin',
    statusPending: 'Pendiente',
    active: 'Activo',
    blocked: 'Bloqueado',
    rejected: 'Rechazado',
    block: 'Bloquear',
    unblock: 'Desbloquear',
    blockedToast: 'Cuenta bloqueada',
    unblockedToast: 'Cuenta desbloqueada',
    manageFailed: 'No se pudo cambiar el estado de la cuenta',
    commissionDefault: 'Por defecto {{pct}}%',
    commissionEdit: 'Editar',
    commissionSave: 'Guardar',
    commissionCancel: 'Cancelar',
    commissionSaved: 'Comisión actualizada.',
    commissionFailed: 'No se pudo actualizar la comisión.',
    lastActions: '{{count}} acciones de administración registradas',
    noBookings: 'No hay reservas.',
    noInvoices: 'No hay facturas.',
    kindCommission: 'Comisión',
    kindLodging: 'Alojamiento',
    vfFiled: 'VeriFactu remitida',
    vfIncidence: 'Incidencia',
    vfPending: 'VeriFactu pendiente',
    navRegistry: 'Directorio',
    vfSubmit: 'Remitir a AEAT',
    vfSubmitted: 'Remitida a AEAT',
    vfSubmitFailed: 'No se pudo remitir a AEAT',
    vfNotConfigured: 'Certificado VeriFactu no configurado',
    void: 'Anular',
    voidConfirm: '¿Anular esta factura? Si fue remitida a AEAT, se enviará una anulación.',
    voidDone: 'Factura anulada',
    voidFailed: 'No se pudo anular la factura',
    voidAnulacionPending: 'Anulación AEAT pendiente de certificado',
    voided: 'Anulada',
    rect: 'Rectificativa',
    rectConfirm: '¿Emitir una rectificativa que sustituya a esta factura?',
    rectDone: 'Rectificativa emitida',
    rectFailed: 'No se pudo emitir la rectificativa',
    registry: {
      addTitle: 'Añadir empresa',
      editTitle: 'Editar empresa',
      listTitle: 'Directorio de empresas',
      cif: 'CIF',
      legalName: 'Razón social',
      street: 'Calle',
      postalCode: 'Código postal',
      city: 'Ciudad',
      province: 'Provincia',
      country: 'País',
      save: 'Guardar',
      saved: 'Empresa guardada',
      saveError: 'No se pudo guardar la empresa',
      deleted: 'Empresa eliminada',
      deleteError: 'No se pudo eliminar la empresa',
      errFields: 'El CIF y la razón social son obligatorios',
      empty: 'Aún no hay empresas en el directorio',
      edit: 'Editar',
    },
  },
  dashboard: {
    roleLabel: 'Rol',
    emailLabel: 'Email',
  },
  notFound: {
    title: 'Página no encontrada',
    desc: 'La página que buscas no existe o ha cambiado de dirección.',
  },
  error: {
    boundaryDesc: 'Algo salió mal. Recarga para continuar.',
    boundaryReload: 'Recargar',
  },
  common: {
    loading: 'Cargando…',
    error: 'Algo salió mal',
    favorite: 'Guardar en favoritos',
    required: 'Obligatorio',
    back: 'Volver',
    retry: 'Reintentar',
    continue: 'Continuar',
    done: 'Hecho',
    save: 'Guardar',
    plusIva: '+ IVA',
    cancel: 'Cancelar',
    rooms: 'habitaciones',
    room: 'habitación',
    bathrooms: 'baños',
    bathroom: 'baño',
    increment: 'Aumentar',
    decrement: 'Reducir',
    edit: 'Editar',
    close: 'Cerrar',
    previous: 'Anterior',
    next: 'Siguiente',
  },
  amenities: {
    wifi: 'Wifi',
    parking: 'Aparcamiento',
    ac: 'Aire acondicionado',
    heating: 'Calefacción',
    washing: 'Lavadora',
    dishwasher: 'Lavavajillas',
    elevator: 'Ascensor',
    furnished: 'Amueblado',
    kitchen: 'Cocina',
    meeting_room: 'Sala de reuniones',
    printer: 'Impresora',
    gym: 'Gimnasio',
  },
} as const
